import { render, staticRenderFns } from "./KidsOrdersList.vue?vue&type=template&id=22d07d80&scoped=true&"
import script from "./KidsOrdersList.vue?vue&type=script&lang=js&"
export * from "./KidsOrdersList.vue?vue&type=script&lang=js&"
import style0 from "./KidsOrdersList.vue?vue&type=style&index=0&id=22d07d80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d07d80",
  null
  
)

export default component.exports